<template>
  <div v-if="isLinked" :class="[$style.chip, isExcluded ? $style.exclude : $style.include]">
    <VdIcon
      store="fas"
      :name="isExcluded ? 'ban' : 'circle-check'"
      size="small"
      custom-size="12px"
      :color="iconColor"
    />
    <span>{{ label }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import VdIcon from "@/components/VdIcon/VdIcon.vue";

const props = defineProps({
  // Legacy single-link scalar; kept as a fallback for offers not yet on the multi-link shape.
  abTestId: {
    type: String,
    default: null,
  },
  abtestLinkMode: {
    type: String,
    default: null,
  },
  abtestLinks: {
    type: Array,
    default: () => [],
  },
});

// Multi-link / EXCLUDE offers carry a null scalar abTestId, so the chip keys on the effective link set.
const effectiveLinks = computed(() => {
  if (props.abtestLinks && props.abtestLinks.length > 0) {
    return props.abtestLinks;
  }
  if (props.abTestId) {
    return [{ abTestId: props.abTestId, cohortId: null }];
  }
  return [];
});

const isLinked = computed(() => effectiveLinks.value.length > 0);
const isExcluded = computed(() => props.abtestLinkMode === "EXCLUDE");
// Count the distinct linked cohorts (falling back to the raw link count for legacy scalar links that
// don't carry a cohort id).
const cohortCount = computed(() => {
  const cohortIds = new Set(effectiveLinks.value.map((link) => link.cohortId).filter(Boolean));
  return cohortIds.size || effectiveLinks.value.length;
});

const label = computed(() => {
  const noun = cohortCount.value === 1 ? "cohort" : "cohorts";
  return `${isExcluded.value ? "Excluded" : "Included"} · ${cohortCount.value} ${noun}`;
});

const iconColor = computed(() => (isExcluded.value ? "#b91c1c" : "#15803d"));
</script>

<style module>
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.include {
  background-color: #dcfce7;
  color: #15803d;
}

.exclude {
  background-color: #fee2e2;
  color: #b91c1c;
}
</style>
